var exports = {
  "N1": "ChannelHeader.module__headerContainer___eVB2Uj",
  "dL": "ChannelHeader.module__headerWrapper___eVB2Uj",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___eVB2Uj",
  "hE": "ChannelHeader.module__headerContainerCallActive___eVB2Uj",
  "Ud": "ChannelHeader.module__headerLeftSection___eVB2Uj",
  "Gv": "ChannelHeader.module__backButton___eVB2Uj",
  "wK": "ChannelHeader.module__backButtonDesktop___eVB2Uj" + " " + "ChannelHeader.module__backButton___eVB2Uj",
  "j2": "ChannelHeader.module__backIcon___eVB2Uj",
  "Ir": "ChannelHeader.module__backIconBold___eVB2Uj" + " " + "ChannelHeader.module__backIcon___eVB2Uj",
  "CY": "ChannelHeader.module__leftContentContainer___eVB2Uj",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___eVB2Uj",
  "BN": "ChannelHeader.module__mobileButton___eVB2Uj",
  "Vt": "ChannelHeader.module__desktopButton___eVB2Uj" + " " + "ChannelHeader.module__mobileButton___eVB2Uj",
  "R3": "ChannelHeader.module__avatarWrapper___eVB2Uj",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___eVB2Uj",
  "_D": "ChannelHeader.module__groupDmHeaderInner___eVB2Uj",
  "ab": "ChannelHeader.module__groupDmEditIcon___eVB2Uj",
  "HA": "ChannelHeader.module__channelName___eVB2Uj",
  "$7": "ChannelHeader.module__groupDmChannelName___eVB2Uj",
  "kf": "ChannelHeader.module__dmNameWrapper___eVB2Uj",
  "a1": "ChannelHeader.module__userTag___eVB2Uj",
  "p": "ChannelHeader.module__channelIcon___eVB2Uj",
  "ml": "ChannelHeader.module__caretRight___eVB2Uj",
  "Nj": "ChannelHeader.module__channelInfoContainer___eVB2Uj",
  "u8": "ChannelHeader.module__followButton___eVB2Uj",
  "B6": "ChannelHeader.module__topicDivider___eVB2Uj",
  "zm": "ChannelHeader.module__topicContainer___eVB2Uj",
  "yu": "ChannelHeader.module__topicButton___eVB2Uj",
  "Am": "ChannelHeader.module__topicButtonOverflow___eVB2Uj",
  "lY": "ChannelHeader.module__headerRightSection___eVB2Uj",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___eVB2Uj",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___eVB2Uj",
  "gb": "ChannelHeader.module__iconButton___eVB2Uj",
  "f5": "ChannelHeader.module__iconButtonDefault___eVB2Uj" + " " + "ChannelHeader.module__iconButton___eVB2Uj",
  "vR": "ChannelHeader.module__iconButtonSelected___eVB2Uj" + " " + "ChannelHeader.module__iconButton___eVB2Uj",
  "rB": "ChannelHeader.module__updateIconButton___eVB2Uj" + " " + "ChannelHeader.module__iconButton___eVB2Uj",
  "l_": "ChannelHeader.module__updateIcon___eVB2Uj",
  "Do": "ChannelHeader.module__updateIconSpinning___eVB2Uj" + " " + "ChannelHeader.module__updateIcon___eVB2Uj",
  "bx": "ChannelHeader.module__updateIconSpin___eVB2Uj",
  "IC": "ChannelHeader.module__iconButtonMobile___eVB2Uj",
  "iA": "ChannelHeader.module__buttonIcon___eVB2Uj",
  "qt": "ChannelHeader.module__buttonIconMobile___eVB2Uj",
  "Dm": "ChannelHeader.module__iconButtonWrapper___eVB2Uj",
  "W9": "ChannelHeader.module__unreadPinIndicator___eVB2Uj",
};

module.exports = exports;
